import { Stack } from '@mui/material'
import { PageHeaderContainer } from '@/components/page-header'
import { ProductHeaderActions } from '@/components/product-switcher/product-header-actions'
import { ProductSwitcherButton } from '@/components/product-switcher'

export function AppHeader() {
  return (
    <PageHeaderContainer>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        gap={3}
      >
        <ProductSwitcherButton />
        <ProductHeaderActions />
      </Stack>
    </PageHeaderContainer>
  )
}
